import { render } from "./holes_row_compact.vue?vue&type=template&id=33985ca5"
import script from "./holes_row_compact.vue?vue&type=script&lang=js"
export * from "./holes_row_compact.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__